import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./ResultsPage.css";
import printIcon from "../assets/icons/icon_print1.svg"
import closeIcon from "../assets/icons/icon_close1.svg"
import getLatestVerification from '../services/verificationRecordsSort';

export default function ResultsPage() {
    const location = useLocation();
    const [asset, setAsset] = useState(null);
    const [style, setStyle] = useState('');

    useEffect(() => {
        if (location.state?.asset) {
            setAsset(location.state.asset);
        }
    }, [location]);

    useEffect(() => {
        if (asset) {
            if (asset.asset_type === 'Computer' || asset.asset_type === 'Servers') {
                setStyle('');
            } else {
                setStyle('hiddenClass');
            }
        }
    }, [asset]);

    if (!asset) {
        return <div className="asset-container"><p>No asset data available</p></div>;
    }

   const verification = getLatestVerification(asset.verification);
    console.log("from result Page , Verification : ",verification);

    const software = asset.sw_desc ? asset.sw_desc.split('|') : [];



    const handleClose = () => {
        window.history.back();
    };

    const formatDate = (isoString) => {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    return (
        <div className="asset-container" style={{ fontFamily: 'GEG-Light, Arial, sans-serif' }}>
            <div className="header">
                <div className="header-icons">
                    <img src={printIcon} alt="Print" className="icon" onClick={() => window.print()} title="Print" />
                    <img src={closeIcon} alt="Close" className="icon" onClick={handleClose} title="Close" />
                </div>
            </div>

            <h2 className="form-title">ACKOWLEDGEMENT AND UNDERTAKING FOR IT ASSETS</h2>

            <section className="undertaking">
                <p style={{ textIndent: '3em' }}>I hereby confirm that the below mentioned asset is provided by the company to me for official use.</p>
            </section>

            <section className="form-section">
                <h3>Asset Details :</h3>
                <table className="form-table">
                    <tbody>
                        <tr><td>Asset No</td><td colSpan={3}>{asset.asset_no}</td></tr>
                        <tr><td>Asset Type</td><td>{asset.asset_type}</td>
                            <td>Asset Sub Type</td><td>{asset.asset_sub_type}</td></tr>
                        <tr><td>Asset Make</td><td>{asset.asset_make}</td>
                            <td>Asset Model</td><td>{asset.asset_model}</td></tr>
                        <tr><td>Asset Sr No</td><td colSpan={3}>{asset.asset_srno}</td></tr>
                        <tr><td>Email ID</td><td>{asset.emailId}</td>
                            <td>Extn</td><td>{asset.extn || ''}</td></tr>
                        <tr><td>BC/RC/CC</td><td colSpan={3}>{asset.bc || ''} / {asset.rc || ''} / {asset.cc || ''}</td></tr>
                        <tr><td>Phone</td><td>{asset.phone || ''}</td>
                            <td>Mobile</td><td>{asset.mobile || ''}</td></tr>
                        <tr><td>Users</td><td>{asset.users}</td>
                            <td>Company</td><td>{asset.comp}</td></tr>
                        <tr><td>HO / Branch</td><td>{asset.ho}</td>
                            <td>Plant / Branch</td><td>{asset.plant_branch}</td></tr>
                        <tr><td>Division</td><td>{asset.div}</td>
                            <td>Department</td><td>{asset.dept}</td></tr>
                        <tr><td>IP Address</td><td>{asset.ip || ''}</td>
                            <td>MAC Address</td><td>{asset.mac || ''}</td></tr>
                    </tbody>
                </table>
            </section>

            <section className={`${style} form-section`}>
                <h3>Desktop / Server Details :</h3>
                <table className="form-table">
                    <tbody>
                        <tr><td>Monitor Type</td><td>{asset.monitor_type}</td>
                            <td>CD Drive</td><td>{asset.cd_drive}</td></tr>
                        <tr><td>Monitor Size</td><td>{asset.monitor_size}</td>
                            <td>PC Type</td><td>{asset.pc_type}</td></tr>
                        <tr><td>RAM</td><td>{asset.ram}</td>
                            <td>HDD</td><td>{asset.hdd}</td></tr>
                    </tbody>
                </table>
            </section>

            <section className={`${style} form-section`}>
                <h3>OS Details :</h3>
                <table className="form-table">
                    <tbody>
                        <tr><td>OS</td><td>{asset.os_desc}</td>
                            <td>OS Version</td><td>{asset.os_version || ''}</td></tr>
                    </tbody>
                </table>
            </section>

            <section className={`${style} form-section`}>
                <h3>Software Details :</h3>
                <table className="soft">
                    <tbody>
                        <tr><td>Sr No</td><td>Software</td><td>Software Version</td><td>Sr No</td><td>Software</td><td>Software Version</td></tr>
                        {software.map((sw, idx) => {
                            const [name, version] = sw.split('_');
                            if (idx % 2 === 0) {
                                const nextSw = software[idx + 1];
                                const [nextName, nextVersion] = nextSw ? nextSw.split('_') : ['', ''];
                                return (
                                    <tr key={idx}>
                                        <td>{idx + 1}</td>
                                        <td>{name}</td>
                                        <td>{version}</td>
                                        <td>{nextSw ? idx + 2 : ''}</td>
                                        <td>{nextName}</td>
                                        <td>{nextVersion}</td>
                                    </tr>
                                );
                            }
                            return null;
                        })}
                    </tbody>
                </table>
            </section>

            <section className={`${style} form-section`}>
                <h3>Verification Details :</h3>
                <table className="form-table">
                    <tbody>
                        <tr><td>Accept/Reject</td><td>{verification.accepted ? 'Accepted' : 'Pending'}</td>
                            <td>Remark</td><td>{verification.remarks}</td></tr>
                        <tr><td>Verified By</td><td>{verification.verified_by}</td>
                            <td>Verified On</td><td>{formatDate(verification.verified_on)}</td></tr>
                    </tbody>
                </table>
            </section>

            <section className="undertaking">
                <p style={{ textIndent: '3em' }}>If there is any change in the above information, I will immedialty inform OTG Department of Godrej Infotech Ltd. Since the equipment may be covered under warranty or lease financing, and the software may be licensed, i understand that any tampering with asset may bring financial looses to the company , Hence I will take following precautions:</p>
                <ol type="a">
                    <li>I will not make any changes to the hardware</li>
                    <li>I will not uninstall or reinstall licensed software provided with the equipment</li>
                    <li>I will take necessary approvals before installing any additional software, Even if software is free, the compatibility needs to be checked with the existing software</li>
                    <li>I will take regular backup of my important official files and emails since system can crash anytime without warning. I will use passwords to protect the information stored from unauthorized access</li>
                    <li>I will remove unecessary files and emails to free the system resources and keep the system clean and tidy</li>
                    <li>I will allow physical verification of asset whenever deputed person visits or confirm through eamil whenver asked for the same</li>
                    <li>I will surrender the asset for re-deployment if I do not need it.</li>
                    <li>I will use the equipment carefully. I will use the delicate asset like laptop safely to prevent theft and/or damages</li>
                </ol>
                <p>I confirm that i will be responsible for handing over the equipment in proper condition along with accessories when:</p>
                <ol type="i">
                    <li>I am transferred</li>
                    <li>I leave the organization</li>
                    <li>Lease period gets over for leased assets</li>
                    <li>Company asks for it</li>
                </ol>
                <p style={{ textIndent: '3em' }}>I will fill the asset tranfer form and get it approved to relinquish the responsibility of the asset. I understand that the company at the sole discretion, may recover the amount wither fully or partly , alongwith the cost of software , if the asset is not returned and asset transfer is not done as given above</p>
                <p style={{ textIndent: '3em' }}>While using the asset everyday , I will abide by IT usage and Information Security policies published on Intranet - Godrej IT Services web site -<br /> http://itservices.godrejenterprises.com/</p>
                    <div className="signature-section-normal" style={{ textAlign: 'left', paddingRight: '100px' }}>
                        <p className='print-privew' style={{ textIndent: '40em' }}><b>Sign :</b></p>
                        <br />
                        <p className='print-privew' style={{ textIndent: '40em' }}><b>Name : {asset.users}</b></p>
                        <br />
                        <p className='print-privew' style={{ textIndent: '40em' }}><b>Date :</b></p>
                    </div>

                    {/* Print view */}
                    <div className="signature-section-print">
                        <div className="signature-content-print">
                            <p><b>Sign :</b></p>
                            <br />
                            <p><b>Name : {asset.users}</b></p>
                            <br />
                            <p><b>Date :</b></p>
                        </div>
                    </div>
                <ol>
                    <p>{`AssetNo.- ${asset.asset_no} /Asset Registered Against(Email ID)-${asset.emailId}`}</p>
                </ol>
            </section>
        </div>
    )
}
